var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.25C12.4142 4.25 12.75 4.58579 12.75 5L12.75 15.1287L16.159 11.7197C16.4519 11.4268 16.9268 11.4268 17.2197 11.7197C17.5126 12.0126 17.5126 12.4875 17.2197 12.7803L12.6235 17.3765C12.4533 17.5467 12.2217 17.618 12 17.5904C11.7783 17.618 11.5467 17.5467 11.3765 17.3765L6.78033 12.7803C6.48744 12.4875 6.48744 12.0126 6.78033 11.7197C7.07322 11.4268 7.5481 11.4268 7.84099 11.7197L11.25 15.1287L11.25 5C11.25 4.58579 11.5858 4.25 12 4.25ZM3.25 21C3.25 20.5858 3.58579 20.25 4 20.25H20C20.4142 20.25 20.75 20.5858 20.75 21C20.75 21.4142 20.4142 21.75 20 21.75H4C3.58579 21.75 3.25 21.4142 3.25 21Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.1aeeccccb81fd1f1e713e6aaf01dc644.svg";
export { ForwardRef as ReactComponent };